<template>
  <div class="office-plugin-wrap">
    <div class="office-plugin" @click.capture="handlePageClick($event)">
        <div class="title">
            <div>V9.0 NEXT版 流版签插件推荐助手</div>
        </div>
        <!-- 产品选择 -->
        <div class="product-select-box page-block">
          <div class="product-select-left">
            <SubTitle text="产品版本（V9.0 NEXT）" :isWhite="true"></SubTitle>
            <div class="product-header-menu">
              <div v-for="(value, key) in productMap" :key="key" 
                :class="{ 
                'selected': productVersion  === key ,
                'product-select-options':true}" 
                @click="changeProduct(key, value)" 
                >
                {{ key }}
              </div>
            </div>
            <div class="product-header-info">
                <div>提示说明：</div>
                <div>请依次选择产品版本以及核心业务的场景，我们会根据所选内容推荐合理的插件方案供您选择。</div>
            </div>
          </div>
          <div class="product-select-right">
            <!-- 核心业务 -->
            <SubTitle text="核心业务"></SubTitle>
            <div class="core-business-content">
              <label class="business-item" v-for="(value, key) in sceneMap" :key="key" v-show="!showScene(key)">
                  <div class="business-item-header">
                    <input v-if="showRadio" type="radio" :value="value" @change="changeScene(key)" v-model="sceneModel">
                    <div class="business-item-header-title">{{ value.show }}</div>
                  </div>
                  <div class="business-item-content">
                    <div class="business-item-name">适用场景：</div>
                    <div class="business-item-stage" v-html="value.desc"></div>
                  </div>
              </label>
              <div class="business-item-blank" v-for="i of 2" :key="i+'div'"></div>
            </div>
          </div>
        </div>
        
        <!-- 推荐方案 -->
        <div class="plan-box page-block" v-show="filterPlanKeys.length">
          <SubTitle text="推荐方案">
            <div class="plan-title-des">请联系商务选购以下插件组合</div>
          </SubTitle>
          <div class="plan-list">
            <div class="plan-list-item" v-for="(planKey, index) in filterPlanKeys" :key="index">
              <label class="plan-list-item-content">
                <div class="plan-item-header">
                  <input type="radio" :value="planMap[planKey]" @change="changePlan()" v-model="planModel">
                  <div class="plan-item-header-title">{{ planMap[planKey].show }}</div>
                </div>
                <div class="plugin-content">
                  <div class="plugin-content-item" v-for="(value, key) in pluginMap" :key="key" v-show="(pluginModel||[]).includes(key)">
                    {{ value.show }}
                  </div>
                </div>
                <div class="plan-item-content">
                  <div class="" v-for="(includePluginKey, index) in planMap[planKey].includePluginKeys" :key="index">
                    <span :class="'plugin-type'+tagKeyOptions[includePluginKey]" class="plugin-type" v-text="thirdPluginMap[includePluginKey].show"></span>
                  </div>
                </div>
              </label>
              <div class="plan-item-compare plan-list-item" v-if="index > 0">
                <div v-for="(includePluginKey, index) in planMap[planKey].includePluginKeys" :key="index" >
                  <div v-if="planMap[planKey].desc != '' && index == 0" class="plan-item-header-title">方案对比</div>
                  <div class="plan-item-compare-content" :rowspan="index" v-if="planMap[planKey].desc != '' && index == 0" v-text="planMap[planKey].desc"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="function-desc page-block" v-if="planModel.includePluginKeys">
          <SubTitle text="功能说明"></SubTitle>
          <!-- 在线预览 -->
          <div class="table-block" v-if="showViewOnline">
            <div class="table-block-title">在线预览</div>
              <table>
                  <thead>
                      <tr>
                          <th>端</th>
                          <th>分类</th>
                          <th>功能点</th>
                          <th v-for="(pluginKey, index) in pluginMap.ViewOnlinePlugin.thirdPlugins" :key="index">{{ thirdPluginMap[pluginKey].show }}</th>
                          <th>备注</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr v-for="(item, index) in viewTableData" :key="index">
                          <td :rowspan="item.deviceRowCount" v-if="item.showDevice">{{ item.device }}</td>
                          <td :rowspan="item.typeRowCount" v-if="item.showType">{{ item.type }}</td>
                          <td>{{ item.show }}</td>
                          <td v-for="(pluginKey, index) in pluginMap.ViewOnlinePlugin.thirdPlugins"
                              :key="index"
                              :class="{'dark-td': planModel.includePluginKeys.includes(pluginKey)}"
                              v-html="functionSupportName(item.key, pluginKey)"></td>
                          <td class="remark">{{ item.remark }}</td>
                      </tr>
                  </tbody>
              </table>
          </div>

          <!-- 在线编辑 -->
          <div class="table-block" v-if="showEditOnline">
            <div class="table-block-title">在线编辑</div>
              <table>
                  <thead>
                      <tr>
                          <th>端</th>
                          <th>分类</th>
                          <th>功能点</th>
                          <th v-for="(pluginKey, index) in pluginMap.EditOnlinePlugin.thirdPlugins" :key="index">{{ thirdPluginMap[pluginKey].show }}</th>
                          <th>备注</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr v-for="(item, index) in editTableData" :key="index">
                          <td :rowspan="item.deviceRowCount" v-if="item.showDevice">{{ item.device }}</td>
                          <td :rowspan="item.typeRowCount" v-if="item.showType">{{ item.type }}</td>
                          <td>{{ item.show }}</td>
                          <td v-for="(pluginKey, index) in pluginMap.EditOnlinePlugin.thirdPlugins"
                              :key="index"
                              :class="{'dark-td': planModel.includePluginKeys.includes(pluginKey)}"
                              v-html="functionSupportName(item.key, pluginKey)"></td>
                          <td class="remark">{{ item.remark }}</td>
                      </tr>
                  </tbody>
              </table>
          </div>
        </div>

        <div class="function-desc page-block"  v-if="showServerConfig">
          <SubTitle text="服务器配置推荐"></SubTitle>
          <div v-if="serverConfigPluginKeys.length > 0">
                    <div v-for="(pluginKey, index) in serverConfigPluginKeys"  :key="index" class="table-block">
                        <div class="table-block-title">{{ thirdPluginMap[pluginKey].show }}</div>
                        <table v-if="Array.isArray(serverConfigMap[pluginKey])">
                            <thead>
                                <tr>
                                    <th>配置</th>
                                    <th>OA同时在线人数</th>
                                    <th>日活用户数</th>
                                    <th>文档并发数</th>
                                    <th>备注</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(serverConfig, index1) in serverConfigMap[pluginKey]" :key="index1">
                                    <td>{{ serverConfig.cpu }}</td>
                                    <td>{{ serverConfig.online }}</td>
                                    <td>{{ serverConfig.active }}</td>
                                    <td>{{ serverConfig.batch }}</td>
                                    <td class="remark" v-html="serverConfig.remark"></td>
                                </tr>
                            </tbody>
                        </table>

                        <div v-if="!Array.isArray(serverConfigMap[pluginKey])" class="table-block-content">{{ serverConfigMap[pluginKey] }}</div>
                    </div>
                </div>
        </div> 
        <!-- 注意事项 -->
        <div class="function-desc page-block" v-show="planModel.includePluginKeys">
          <SubTitle text="注意事项"></SubTitle>
            <div class="table-block"  v-show="Object.keys(planModel).length > 0">
                <table>
                    <thead>
                        <tr>
                            <th width="50px">序号</th>
                            <th width="300px">插件</th>
                            <th width="100px">类别</th>
                            <th>描述</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(noteKey, index) in noteModel" :key="index">
                            <td>{{ index + 1 }}</td>
                            <td>
                              <div class="plugin-tag">
                                <span v-for="(pluginKey, index1) in planModel.includePluginKeys" :key="index1">
                                  <span v-if="thirdPluginMap[pluginKey].noteKeys.includes(noteKey)"  :class="'plugin-type'+(tagKeyOptions[pluginKey]||7)" class="plugin-type">
                                    {{ thirdPluginMap[pluginKey].show }}
                                  </span>
                                </span>
                                </div>
                            </td>
                            <td>{{ noteMap[noteKey].type }}</td>
                            <td class="remark" v-html="noteMap[noteKey].desc"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- 技术支持 -->
        <div class="support-content">
          <span>内容提供：研发中心-V5产品管理及运营部、用户体验设计部</span>
          <span class="support-content-ml">技术支持：实施交付中心</span>
        </div>
        <div class="watermark" id="watermark" :style="{'pointer-events': onlyView ? '' : 'none'}"></div>
    </div>
  </div>
</template>

<script>
import { getCookie } from "@/utils/common";
import axios from 'axios';
import SubTitle from './components/SubTitle.vue'
import Iyes from '@/assets/imgs/yes.png'
import Ino from '@/assets/imgs/no.png'

export default {
  name: 'officePlugin',
  components: {SubTitle},
  methods: {
      // 获取后台数据
      getOfficePluginData() {
          let url = '/faq/office/plugin/data';
          const token = getCookie('loginKey')
          axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
          axios.defaults.headers.token = token;
          axios.get(url).then(res => {
              if (!res) return;
              let data = res.data;
              if(data.code === 403){
                this.$warning({
                  title: "提示",
                  content: "仅对内部人员（员工、伙伴、客户）开放",
                  centered: true
                })
              }else if(data.code === 0){
                this.onlyView = false;
              }
              if (data.code === 0 || data.code === 401 || data.code === 403) {
                this.productMap = res.data.data.productMap;
                //初始化场景信息
                this.sceneMap = res.data.data.sceneMap;
                //初始化插件信息
                this.pluginMap = res.data.data.pluginMap;
                //初始化推荐方案信息
                this.planMap = res.data.data.planMap;
                //产品方案信息
                this.productPlanMap = res.data.data.productPlanMap;
                //初始化第三方插件信息
                this.thirdPluginMap = res.data.data.thirdPluginMap;
                //初始化注意事项信息
                this.noteMap = res.data.data.noteMap;
                //初始化在线预览表格信息
                this.viewTableData = res.data.data.viewTableData;
                //初始化在线编辑表格信息
                this.editTableData = res.data.data.editTableData;
                //初始化服务器配置信息
                this.serverConfigMap = res.data.data.serverConfigMap;
                
                // 默认选中第一个
                this.productVersion = Object.keys(this.productMap)[0] || '';
                this.changeProduct(this.productVersion, this.productMap[this.productVersion]);
                // 水印
                let cookieNickName = getCookie("nickName");
                let cookieLoginKey = getCookie('loginKey');
                if (cookieNickName && cookieLoginKey) {
                  this.createWatermark(unescape(cookieNickName) + '  ' + this.getCurrentDate());
                }
              }
          })
      },
      // 切换产品
      changeProduct(key, value) {
        //重置数据
        this.sceneModel = {};
        this.pluginModel = [];
        this.planModel = {};
        this.serverConfigPluginKeys = [];
        this.productModel.key = key;
        this.productModel.exclude = value;
        
        this.productVersion  = key;
        
        // this.changeScene(Object.keys(this.sceneMap)[0]); 
      },
      // 切换场景
      changeScene(key){
          //重置数据
          this.pluginModel = this.sceneModel.pluginKeys;
          this.sceneModel = this.sceneMap[key];
          this.serverConfigPluginKeys = [];

          // 只有一个方案默认选中
          if(this.filterPlanKeys && this.filterPlanKeys.length == 1){
              this.planModel = this.planMap[this.filterPlanKeys[0]];
              this.changePlan();
          }else{
              this.planModel = {};
              this.noteModel = new Set();
          }
          // 把推荐方案滚动到页面显示
          this.$nextTick(()=>{
              const div = document.querySelector('.office-plugin-wrap');
              if(div && div.scrollTop < 400){
                  div.scrollTop = 400
              }
          })
          // this.planModel = this.planMap[this.sceneModel.planKeys[0]];
          // this.changePlan();
      },
      // 场景是否可选
      showScene(key) {
          //没有选择产品，全部置为不可选
          if(typeof(this.productModel.exclude) == "undefined" || (this.productModel.exclude && this.productModel.exclude.includes(key) > 0)){
              return true;
          }
          return false;
      },
      // 切换推荐方案
      changePlan() {
          //重置数据
          this.noteModel = new Set();
          this.serverConfigPluginKeys = [];

          for(const pluginKey of this.planModel.includePluginKeys){
              this.thirdPluginMap[pluginKey].noteKeys.forEach(item => this.noteModel.add(item));
              if(this.serverConfigMap[pluginKey]){
                  this.serverConfigPluginKeys.push(pluginKey);
              }
          }
      },
      // 转换在线预览数据结构
      convertTableData(tableData) {
          //计算合并单元格行数
          let rowMap = {};
          let device = "", deviceType = "";
          for (const item of tableData) {

              if(device !== item.device){
                  rowMap[item.device] = 1;
              }else{
                  rowMap[item.device] += 1;
              }

              let itemDeviceType = item.device + "_" + item.type;
              if(deviceType !== itemDeviceType){
                  rowMap[itemDeviceType] = 1;
              }else{
                  rowMap[itemDeviceType] += 1;
              }

              device = item.device;
              deviceType = itemDeviceType;
          }

          // 转换数据结构
          device = "";
          deviceType = "";
          for (const item of tableData) {
              if(device !== item.device){
                  item.showDevice = true;
                  item.deviceRowCount = rowMap[item.device];
              }else{
                  item.showDevice = false;
                  item.deviceRowCount = 1;
              }

              let itemDeviceType = item.device + "_" + item.type;
              if(deviceType !== itemDeviceType){
                  item.showType = true;
                  item.typeRowCount = rowMap[itemDeviceType];
              }else{
                  item.showType = false;
                  item.typeRowCount = 1;
              }

              device = item.device;
              deviceType = item.device + "_" + item.type;
          }
      },
      // 功能支持信息展示
      functionSupportName(funcKey, pluginKey){
          if(this.thirdPluginMap[pluginKey].functionKeys.includes(funcKey)){
              if(this.thirdPluginMap[pluginKey].customShow && this.thirdPluginMap[pluginKey].customShow[funcKey]){
                  return `<img src="${this.Img.Iyes}"> ${this.thirdPluginMap[pluginKey].customShow[funcKey]}`;
              }
              return `<img src="${this.Img.Iyes}">`;
          }else{
              return `<img src="${this.Img.Ino}">`;
          }
      },
      openOfficePlugin() {
          let cookie = getCookie('loginKey');
          if (!cookie) {
              this.$confirm({
                  title: '提示',
                  content: '仅对内部人员（员工、伙伴、客户）开放，如需使用请登录',
                  okText: '去登录',
                  cancelText: '取消',
                  centered: true,
                  onOk: ()=> {
                    // this.$router.push({name: 'login',query: { fromType: 'officePlugin' }})
                    this.$toLogin();
                  },
                  onCancel: ()=> {

                  }
              })
              return;
          }
          this.$router.push({name: 'officePlugin'})
      },
      getCurrentDate(){
        const now = new Date();
        const year = now.getFullYear();
        const month = (now.getMonth() + 1).toString().padStart(2, '0');
        const day = now.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
      },
      createWatermark(text){
        const watermark = document.getElementById('watermark');

        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        // 计算文本的宽度
        const textWidth = ctx.measureText(text).width;

        canvas.width = textWidth + 300;
        canvas.height = textWidth + 100;
        ctx.font = `20px Arial`;
        ctx.fillStyle = 'rgba(0, 0, 0, 0.1)';
        ctx.rotate(-30 * Math.PI / 180);

        // 绘制水印
        ctx.fillText(text, 0, canvas.height);

        watermark.style.backgroundImage = `url(${canvas.toDataURL('image/png')})`;
      },
      handlePageClick(e){
        if(this.onlyView){
          e.stopPropagation();
          e.preventDefault();
          return
        }
      }
  },
  created() {
    this.openOfficePlugin()
    this.getOfficePluginData();
  },
  data() {
      return {
          productMap: {}, // 产品信息
          productPlanMap: {}, // 产品方案关系
          productModel: {}, // 选择的产品信息
          sceneMap: {}, // 场景信息
          sceneModel: {}, // 选择的场景信息
          pluginMap: {}, // 插件信息
          pluginModel: [], // 选择的插件信息
          planMap: {}, // 推荐方案信息
          planModel: {}, // 选择的推荐方案信息
          noteModel: new Set(), // 选择的节点信息
          thirdPluginMap: {}, // 第三方插件信息
          noteMap: {}, // 注意事项信息
          viewTableData: [], // 在线预览表格数据
          editTableData: [], // 在线编辑表格数据
          serverConfigMap: {}, // 服务器配置信息
          serverConfigPluginKeys: [], // 服务器配置插件Keys
          productVersion: '', // 产品版本默认选中第一个选项  
          Img:{
            Iyes: Iyes,
            Ino: Ino,
          },
          tagKeyOptions:{'AsposeViewOnline':1, 'KingSoftEditOnline':2, 'KingSoftViewOnline':3, 'ShukeSign':4, 'ShukeViewOnline':5, 'WendangtongEditOnline':6},
          onlyView: true, // 只能查看页面
      }
  },
  computed: {
    //是否显示在线预览表格
    showViewOnline: function(){
        if(this.sceneModel.pluginKeys && this.sceneModel.pluginKeys.includes("ViewOnlinePlugin")){
            this.convertTableData(this.viewTableData);
            return true;
        }
        return false;
    },
    //是否显示在线编辑表
    showEditOnline: function(){
        if(this.sceneModel.pluginKeys && this.sceneModel.pluginKeys.includes("EditOnlinePlugin")){
            this.convertTableData(this.editTableData);
            return true;
        }
        return false;
    },
    //是否显示服务器配置推荐
    showServerConfig: function(){
        return this.serverConfigPluginKeys.length > 0;
    },
    sceneMapValue(){
      return Object.values(this.sceneMap);
    },
    showRadio(){
      return !this.onlyView;
    },
    filterPlanKeys(){
      // 过滤掉productPlanMap的方案
      if(this.sceneModel && this.sceneModel.planKeys){
        return this.sceneModel.planKeys.filter(item=>!(this.productPlanMap[this.productVersion]||[]).includes(item))
      }
      return [];
    }
  },
  watch: {  
  }, 
  mounted() {
  },   
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.office-plugin-wrap{
  position: relative;
  height: calc(100vh - 56px);
  margin-top: 56px;
  background-image: url('../../assets/imgs/back-img.png');
  background-repeat: no-repeat;
  background-size: cover;
  overflow-y: scroll;
  scroll-behavior: smooth;
}

.office-plugin {
  position: relative;
  margin: 0 auto;
  padding-top: 10px;
  text-align: center;

  input[type='radio']{
    transform: scale(1.1);
    margin-right: 6px;
  }
  .title{
    margin: 30px 0;
    font-weight: 600;
    font-size: 24px;
    color: #1F2329;
    text-align: center;
  }
  .page-block{
    width: 1120px;
    margin: 0 auto;
  }
  

.function-desc{
  border-radius: 10px;
  padding: 1px 20px;
  background: #F2F6FA;
  margin-bottom: 20px;
}
.plugin-tag{
  text-align: left;
}

.plugin-type{
  display: inline-block;
  padding: 1px 8px;
  border-radius: 2px;
  word-break: keep-all;
  margin: 4px 8px 4px 0;
  font-size: 12px;
}

$bgC: #00000008, #FFEDED, #EDFFFA ,#EFF7E6,#E5F1FF,#FFF4E5,#EBEBFC;
$color: #333333, #FF4141,#36C1A4 ,#61B109, #0077FF, #FF9900,#403FE6;
$borderC: #E8E8E8,  #FFB9B9, #AAEADD,#C3E1A3,#9FCCFF,#FFD79B,#CCD4FF;

@each $c in $color {
  $i: index($color, $c);

  .plugin-type#{$i}{
    color: $c;
    background: nth($bgC, $i);
    border: 1px solid nth($borderC, $i);
  }
}

.opacity-5 {
  opacity: 0.5;
}
.support-content{
  font-weight: 400;
  font-size: 12px;
  color: #646A73;
  text-align: center;
  padding: 16px 0;

  &-ml{
    margin-left: 40px;
  }
}
}
.product-header{
  height: 74px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &-menu{
    flex: 1;
    overflow-y: auto;
    margin-top: 8px;
  }
  &-info{
    padding: 20px 16px;
    font-weight: 400;
    font-size: 12px;
    color: #ffffffcc;
    line-height: 18px;
    text-align: left;
  }
}
.product-select{
  &-box{
    display: flex;
    height: 516px;
    text-align: left;
  }
  &-left{
    width: 200px;
    height: 100%;
    background: #0077FF;
    border-radius: 10px 0 0 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    

    .product-select-options{
      padding: 0 20px;
      width: 100%;
      height: 44px;
      line-height: 44px;
      color: #fff;
      font-size: 16px;
      cursor: pointer;

      &:hover{
        background: rgba(255, 255, 255,0.2);  
      }
      &.selected{
        font-size: 16px;
        color: #0077FF;
        background-image: linear-gradient(90deg, #FFFFFF 4%, #DDEDFF 100%);
      }
    }
  }
  &-right{
    width: 920px;
    height: 100%;
    background: rgba(255, 255, 255, 0.7);
    border-radius: 0 10px 10px 0;
    
    .core-business-content{
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding: 0 20px;
      
      .business-item{
        width: 280px;
        height: 205px;
        background: #FFFFFF;
        border: 1px solid #DBDFE6;
        border-radius: 6px;
        margin-bottom: 20px;
        cursor: pointer;

        &-blank{
          width: 280px;
        }
        &-header{
          height: 70px;
          background-image: url(../../assets/imgs/business-item-header.png);
          display: flex;
          align-items: center;
          padding: 0 14px;
          font-size: 16px;

          &-title{
            font-weight: 600;
            color: #333333;
            letter-spacing: 0;
            line-height: 24px;
          }
        }
        &-name{
          color: #999999;
        }
        &-stage{
          margin-top: 8px;
          line-height: 20px;
        }
        &-content{
          padding: 12px 15px;
          font-size: 12px;
        }
      }
    }
  }
}
.plan-box{
  margin-top: 10px;
  
  .plan-title-des{
    height: 18px;
    font-weight: 400;
    font-size: 12px;
    color: #666666;
    letter-spacing: 0;
    line-height: 18px;
    margin-bottom:4px;
  }
  .plan-list{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    
    &-item{
      border-radius: 6px;
      display: flex;
      text-align: left;
      margin-bottom: 20px;
      height: 280px;

      & + .plan-list-item{
        margin-left: 20px;
      }
      &-content{
        width: 260px;
        display: flex;
        flex-direction: column;
        padding: 16px;
        background: #CEE5FF;
        border: 1px solid #DBDFE6;
        border-radius: 6px;
        cursor: pointer;
      }
      
      .plugin-content{
        margin-top: 15px;
        height: 90px;
        background: #FFFFFF;
        border-radius: 6px;
        padding: 12px 16px;
        color: #333;
        font-size: 14px;
      }
      .plan-item-header-title{
          display: inline-block;
          font-weight: 600;
          font-size: 16px;
          color: #333333;
        }
      .plan-item-content{
        height: 106px;
        margin-top: 12px;
        background: #FFFFFF;
        border-radius: 6px;
        padding: 4px 16px;
        color: #0077FF
      }
    }
      
    .plan-item-compare{
      width: 260px;
      background: #F2F6FA;
      margin-left: 20px;
      padding: 16px;
      border: 1px solid #DBDFE6;
      &-content{
        margin-top: 14px;
        height: 208px;
        background: #FFFFFF;
        border-radius: 6px;
        padding: 12px 16px;
        font-size: 14px;
        color: #333333;
        line-height: 22px;
      }
    }
  }
}
.table-block{
  text-align: left;
  position: relative;
  margin-bottom: 20px;

  &:before{
    content: '';
    display: inline-block;
    width: 120px;
    height: 20px;
    position: absolute;
    left: 0;
    top: 25px;
    /* background: top / contain url('../../assets/imgs/table-title.png') no-repeat; */
    background: linear-gradient(80deg, #0077FF 0%, #E5F1FF 100%);
  }

  &-title{
    font-weight: 500;
    font-size: 14px;
    color: #FFFFFF;
    padding: 2px 16px;
    position: relative;
    display: inline-block;
    min-width: 120px;
    background: linear-gradient(80deg, #0077FF 0%, #E5F1FF 100%);
    border-top-left-radius: 10px;
    border-bottom-right-radius: 10px;
    text-align: center;
  }
  &-content{
    padding: 8px 20px;
  }
  &-content, table{
    position: relative;
    width: 100%;
    background: #fff;
    border-top-left-radius: 16px;
    overflow: hidden;
    font-size: 12px;
  }
  th, td {
    border: 1px solid #E4E7ED;
    text-align: center;
  }
  th{
    padding: 8px 10px;
    background: rgba(#0077FF,0.15);
  }
  td{
    padding: 8px 10px;
    color: #000;
    
    ::v-deep img{
      width: 14px;
    }
  }
  .remark{
    text-align: left;
  }
  .dark-td{
    background: #F3F5FB;
  }
}

.watermark {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* pointer-events: none; */
  z-index: 100;
  overflow: hidden;
}
</style>